import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { FacultyDepartmentRoutingModule } from './faculty-department-routing.module';
import { FacultyDepartmentListComponent } from './faculty-department-list/faculty-department-list.component';
import { FacultyDepartmentCreateComponent } from './faculty-department-create/faculty-department-create.component';

@NgModule({
  declarations: [FacultyDepartmentListComponent, FacultyDepartmentCreateComponent],
  imports: [
    CommonModule,
    FacultyDepartmentRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class FacultyDepartmentModule { }
